<template>
  <div>
    <div class="flex flex-wrap items-center ag-grid-table-actions-right">
      <div v-for="(item, index) in tab" :key="index">
        <vs-button
          class="ml-4 tab_label"
          :class="{ tabActive: item.isActive }"
          @click="changeTabActive(item)"
          v-if="item.isShow"
          >{{ item.tab_name }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      tab: "general/tab",
      nowPage: "getNowPage"
    })
  },
  methods: {
    changeTabActive(index) {
      this.$store.dispatch("general/changeTabActive", index);
    }
  },

  updated() {
    // console.log("tab com", this.tab);
  },mounted(){
    console.log("s",this.tab);
  }
};
</script>
<style lang="scss">
.tab_label {
  border-radius: 15px 15px 0px 0px;
  border: solid 1px #324755;
  border-bottom: 0px;
}
.tabActive {
  border: solid 1px #324755;
  border-bottom: 0px;
  background-color: var(--white) !important;
  color: var(--primary) !important;
}
</style>
